import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import SitesService from "./SitesService";
import EtablissementsService from "../etablissements/EtablissementsService";
import Filarial from "../include/filarial";
import Joi from "joi-browser";

export default function SiteCreate() {
    const activeLink = "SITES"

    /*const [nomSite, setNomSite] = useState('')
    const [nomDirigeant, setNomDirigeant] = useState('')
    const [prenomsDirigeant, setPrenomsDirigeant] = useState('')
    const [adresseSite, setAdresseSite] = useState('')
    const [telephoneSite, setTelephoneSite] = useState('')
    const [emailSite, setEmailSite] = useState('')
    const [etablissementId, setEtablissementId] = useState('')*/
    const [etablissements, setEtablissements] = useState([])

    const token = useSelector(state => state.auth.token)
    const navigate = useNavigate()

    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)
    const [errors, setErrors] = useState({});

    const [addFormData, setAddFormData] = useState({
        dirigeantSite: '',
        nomSite: '',
        adresseSite: '',
        telephoneprimaireSite: '',
        telephonesecondaireSite: '',
        emailSite: '',
        etablissementId: '',
        fondateurSite: '',
    });

    //####GESTION DES REGLES DE VALIDATIONS ###########///
    const schemaAddData = {
        dirigeantSite: Joi.string().max(200).empty('').options({
            language: {
                string: { max: "maximum 200" },
            },
        }).label("Dirigeant Site"),

        nomSite: Joi.string().min(2).max(200).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 200" },
            },
        }).label("Nom Site"),

        etablissementId: Joi.number().integer().min(1).required().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("Etablissement"),

        adresseSite: Joi.string().min(2).max(200).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 200" },
            },
        }).label("Adresse Site"),

        emailSite: Joi.string().email().min(0).max(200).empty('').options({
            language: {
                string: { max: "maximum 200" },
            },
        }).label("Email"),

        telephonesecondaireSite: Joi.number().min(0).max(99999999).empty('').options({
            language: {
                string: { min: "minimum 2 caractères", max: "maximum 200" },
            },
        }).label("Téléphone secondaire"),

        telephoneprimaireSite: Joi.number().min(400).max(99999999).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                number: { min: "minimum 8 caractères", max: "maximum 8" },
            },
        }).label("Telephone primaire"),

        fondateurSite: Joi.string().max(200).empty('').options({
            language: {
                string: { max: "maximum 200" },
            },
        }).label("Fondateur"),

    };


    //####END GESTION DES REGLES DE VALIDATIONS ###########///

    //Gérer les changements sur les formulaires d'ajout
    const handleChange = (event) => {
        //console.log(name)
        const { name, value } = event.target;

        setAddFormData({ ...addFormData, [name]: value });

        let errorData = { ...errors };
        const errorMessage = validateProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...addFormData };
        customerData[name] = event.target.value;
        setAddFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaAddData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    ///Save form data
    const handleSubmitData = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(addFormData,
            schemaAddData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {
            //
            await SitesService.store(addFormData, token).then((response) => {
                //console.log(response.data.data)
                if (response.data.status === 200) {
                    //redirection sur index
                    navigate(myroutes.sites_index)
                    Swal.fire({
                        icon: "success",
                        text: response.data.message
                    })
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000
                    })
                    //setValidationError(response.data.erreur)
                }
            }).catch(error => {
                Swal.fire({
                    icon: "error",
                    text: error.message
                })
                //affichage des erreurs sur le formulaire
                //setValidationError(error.message)
            });
        }

    }

    useEffect(() => {
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }

        //get liste etablissements
        const fetchEtablissements = async () => {
            await EtablissementsService.index(token).then((res) => {
                //console.log(res.data.data)
                setEtablissements(res.data.data.etablissements)
            }).catch(error => {
                console.log(error)
            })
        }

        fetchEtablissements()

    }, [dispatch]);

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                <div className="row mb-4 mt-3">
                    {/* Bootstrap Validation */}
                    <div className="col-md">
                        <div className="card shadow-lg">
                            <h5 className="card-header">Enregistrement </h5>
                            <div className="card-body">
                                <Form className="needs-validation" noValidate onSubmit={handleSubmitData}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-nomSite">Nom Site <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" name="nomSite" id="bs-validation-nomSite" type="text" value={addFormData.nomSite} onChange={handleChange}
                                                placeholder="" required={true} maxLength={100} minLength={3} />

                                            {errors.nomSite && (
                                                <div className="alert alert-danger">
                                                    {errors.nomSite}
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-adresseSite">Adresse Site <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" name="adresseSite" id="bs-validation-adresseSite" type="text" value={addFormData.adresseSite} onChange={handleChange}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                            {errors.adresseSite && (
                                                <div className="alert alert-danger">
                                                    {errors.adresseSite}
                                                </div>
                                            )}
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-telephoneprimaireSite">Telephone primaire <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" name="telephoneprimaireSite" id="bs-validation-telephoneprimaireSite" type="number" value={addFormData.telephoneprimaireSite} onChange={handleChange}
                                                placeholder="" required={true} maxLength={20} minLength={8} />
                                             {errors.telephoneprimaireSite && (
                                                <div className="alert alert-danger">
                                                    {errors.telephoneprimaireSite}
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-telephonesecondaireSite">Telephone secondaire <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" name="telephonesecondaireSite" id="bs-validation-telephonesecondaireSite" type="number" value={addFormData.telephonesecondaireSite} onChange={handleChange}
                                                placeholder="" maxLength={20} minLength={8} />
                                             {errors.telephonesecondaireSite && (
                                                <div className="alert alert-danger">
                                                    {errors.telephonesecondaireSite}
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-emailSite">Email Site <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" name="emailSite" id="bs-validation-emailSite" type="email" value={addFormData.emailSite} onChange={handleChange}
                                                placeholder="" required={true} maxLength={100} minLength={3} />
                                             {errors.emailSite && (
                                                <div className="alert alert-danger">
                                                    {errors.emailSite}
                                                </div>
                                            )}
                                        </div>

                                    </div>

                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-dirigeantSite">Dirigeant <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" name="dirigeantSite" id="bs-validation-dirigeantSite" type="text" value={addFormData.dirigeantSite} onChange={handleChange}
                                                placeholder="" maxLength={100} />
                                            {errors.dirigeantSite && (
                                                <div className="alert alert-danger">
                                                    {errors.dirigeantSite}
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-fondateurSite">Fondateur <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" name="fondateurSite" id="bs-validation-fondateurSite" type="text" value={addFormData.fondateurSite} onChange={handleChange}
                                                placeholder="" maxLength={100} required />
                                            {errors.fondateurSite && (
                                                <div className="alert alert-danger">
                                                    {errors.fondateurSite}
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-name">Etablissements <i className="text-danger">*</i></Form.Label>
                                            <Form.Select className="select2 form-select form-select-md" id="select2Basic" name="etablissementId" value={addFormData.etablissementId} onChange={handleChange} required>
                                                <option value="" disabled selected>-- Selectionnez un etablissement --</option>
                                                {etablissements.length > 0 && etablissements.map(item => (
                                                    <option key={item.id} value={item.id}>{item.raisonsocialeEtablissement}</option>
                                                ))}
                                            </Form.Select>
                                            {errors.etablissementId && (
                                                <div className="alert alert-danger">
                                                    {errors.etablissementId}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <button type="submit" className="btn btn-primary">Enregistrer</button>
                                        </div>
                                    </div>
                                </Form>

                            </div>
                        </div>
                    </div>
                    {/* /Bootstrap Validation */}
                </div>

            </div>

        </Layout>
    )
}